<template>
<div class="text-center">
  <h5 v-if="title" class="white--text">{{title}}</h5>
  <h5 v-if="title" class="">{{title}}</h5>

  <div>
    <img :src="value" style="width:100%;height:auto" alt="Business logo" @click="openFileSelect" v-if="value"/>
    <v-progress-circular :value="upload_progress" color="green" v-else-if="uploading"></v-progress-circular>
    <v-btn icon :color="color ? color : 'primary'" :dark="dark" x-large v-else @click="openFileSelect">
      <v-icon>fa-plus-circle</v-icon>
    </v-btn>
  </div>


  <div class="">
    <v-btn text v-if="value" :dark="dark" x-small @click="clearImage">
      <v-icon x-small>fa-times</v-icon>
    </v-btn>
  </div>

  <input type="file" style="display:none" :id="`file-${random_id}`" @change="handleFileChange($event)" accept="image/*" />
</div>
</template>
<script>
import Axios from "axios";

export default {
  name: "",
  props: ['value', 'title', 'color', 'dark', 'size', 'tile', 'aspect_ratio'],
  data: () => ({
    show_fullscreen: false,
    upload_progress: 0,
    uploading: false,
    random_id: Math.round(Math.random() * 100000)
  }),
  computed: {
    show_clear() {
      if (this.value) {
        return true
      } else {
        return false
      }
    }
  },
  methods: {
    fullscreen() {
      this.show_fullscreen = true
    },
    clearImage() {
      //ping server with url and tell it to delete from s3.
      if (!confirm("Confirm delete ?")) {
        return
      }
      this.$emit('input', null)
      this.$emit('deleted');
    },
    openFileSelect() {
      document.querySelector(`#file-${this.random_id}`).click()
    },
    async uploadFile(file) {
      this.uploading = true
      try {
        this.upload_progress = 0
        let upload_url = await this.$api({
          method: "POST",
          url: `/account/upload-url`,
          data: {
            file: {
              name: file.name,
              size: file.size,
              type: file.type
            },
            key: `images/random-${Math.round(Math.random() * 100)}`
          }
        })
        var upload_options = {
          headers: {
            'Content-Type': file.type,
            'x-amz-acl': 'public-read'
          },
          'Metadata': {
            'Content-Disposition': 'attachment'
          },
          onUploadProgress: function(progressEvent) {
            console.log(progressEvent)
            this.upload_progress = parseInt(Math.round((progressEvent.loaded * 100) / progressEvent.total));
          }.bind(this)
        };
        await Axios.put(upload_url, file, upload_options)
        this.$emit('input', upload_url.split("?")[0])
      } catch (ex) {
        alert("Upload failed")
      }
      this.uploading = false;
    },
    deleteImage: async function() {
      //Tell server to delete file from s3.
      //Set value to no value
    },
    validateFile(file) {
      console.log("Validating file")
      var _URL = window.URL || window.webkitURL;
      let image = new Image();
      image.onload = function() {
        if (image.width / image.height == this['aspect_ratio']) {
          this.uploadFile(file);
        } else {
          alert(`Aspect ratio must be ${this['aspect_ratio']}`);
        }
      }.bind(this)

      image.src = _URL.createObjectURL(file);

    },
    handleFileChange: function(ev) {
      this.$emit('input', null)
      //validate then upload.
      ev.preventDefault();
      let file;
      if (ev.target.files) {
        file = ev.target.files[0]
      }
      console.log("this['aspect_ratio']", this['aspect_ratio'])
      if (file) {
        if (this['aspect_ratio']) {
          this.validateFile(file);
        } else {
          this.uploadFile(file);
        }
      }
      document.querySelector(`#file-${this.random_id}`).value = null;
    }
  }
}
</script>
<style lang="scss" scoped>
.addbox {
    min-height: 200px;
    display: flex;
    align-items: center;
    justify-content: center;
    background-size: cover;
    background-position: center;
}
</style>
